import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const typesForSelect = {
    typesForSelect: null,
    isLoadingTypesForSelect: false,
    isLoadedTypesForSelect: false,
    typesForSelectLoadFailure: null,
};

const limitsTemplates = {
    limitsTemplatesIsLoading: false,
    limitsTemplatesIsLoaded: false,
    limitsTemplates: null,
};


const sidebetNames = {
    sidebetNamesIsLoading: false,
    sidebetNamesIsLoaded: false,
    sidebetNames: null,
};

const operatorsForSelect = {
    operatorsForSelect: null,
    isLoadingOperatorsForSelect: false,
    isLoadedOperatorsForSelect: false,
    operatorsForSelectLoadFailure: null,
};

const currenciesForSelect = {
    currenciesForSelect: null,
    isLoadingCurrenciesForSelect: false,
    isLoadedCurrenciesForSelect: false,
    currenciesForSelectLoadFailure: null,
};

const defaultSettings = {
    defaultSettings: [],
    isLoadingDefaultSettings: [],
    isLoadedDefaultSettings: [],
    defaultSettingsLoadFailure: [],
};

const copyFilter = {
    copyFilterCurrencies: null,
    copyFilterTables: null,
    copyFilterFailure: null,
};

const limitsModule = {
    namespaced: true,
    state: {
        ...typesForSelect,
        ...operatorsForSelect,
        ...currenciesForSelect,
        ...defaultSettings,
        ...copyFilter,
        ...limitsTemplates,
        ...sidebetNames
    },
    mutations,
    actions,
    getters,
};

export default limitsModule;
